/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const order_not_found_busy = () => `Als u zojuist tickets heeft gekocht, kan het zijn dat onze systemen druk zijn. Wacht een paar minuten en probeer het opnieuw. U zou binnenkort een e-mail met uw tickets moeten ontvangen.`
